import React from 'react';
import { updateClassNamesWithPrefix } from '../../utilities/CssUtilities';
import { RenderContext } from '../../utilities/RenderContext';

interface ResponsiveProps {
    className?: string;
    testIdSuffix: string;
    viewMode: 'desktop' | 'desktop-and-tablet' | 'mobile' | 'mobile-and-tablet' | 'tablet';
}

const Responsive: React.FC<ResponsiveProps> = ({ children, className = '', testIdSuffix, viewMode }) => {
    const classNamesByViewMode: Record<typeof viewMode, string> = {
        desktop: `d-none d-lg-block`,
        'desktop-and-tablet': `d-none d-md-block`,
        mobile: `d-block d-md-none`,
        'mobile-and-tablet': `d-block d-lg-none`,
        tablet: `d-none d-md-block d-lg-none`,
    };

    /** The incoming prop className has already been transformed by the react-classname-prefix-loader,
     * which is enabled only for the web-component builds. See webpack/common.js.
     * Based on that, the className prop should not be run through the updateClassNamesWithPrefix function.
     */
    return (
        <RenderContext.Consumer>
            {(value) => (
                <div
                    className={`${className} ${updateClassNamesWithPrefix(
                        classNamesByViewMode[viewMode],
                        value.mode,
                    )}`.trim()}
                    data-testid={`${viewMode}-${testIdSuffix}`}
                >
                    {children}
                </div>
            )}
        </RenderContext.Consumer>
    );
};

export { Responsive, ResponsiveProps };
